const sentryLoader = () =>
  // this is the only place where sentry should be imported
  // eslint-disable-next-line deprecate/import
  import('@sentry/browser')

const optionsDeferred = (() => {
  const deferred = {
    resolve: null,
    reject: null,
    promise: null
  }

  deferred.promise = new Promise((resolve, reject) => {
    deferred.resolve = resolve
    deferred.reject = reject
  })

  return deferred
})()
let sentryInitialized = false

// MUST NOT BE ASYNC OR WE RISK MULTIPLE INITIALIZATIONS
function initSentry (sentryModule, options) {
  if (sentryInitialized) return
  sentryModule.init(options)
  sentryInitialized = true
}

// helper to load the vendor dependency and call the specified method
const loadAndProxy = (name) => async (...args) => {
  // wait for initialization first
  const options = await optionsDeferred.promise
  // load the sentry module
  const sentryModule = await sentryLoader()
  // initialize if needed
  initSentry(sentryModule, options)
  // proxy the call
  return sentryModule[name](...args)
}

export const captureException = loadAndProxy('captureException')
export const withScope = loadAndProxy('withScope')

export function init ({
  eager = false,
  ...options
} = {}) {
  optionsDeferred.resolve(options)
  // fail on second initialization
  optionsDeferred.resolve = () => {
    throw new Error('Sentry already initialized!')
  }

  if (eager) {
    withScope(() => {})
  }
}
